import Vue from 'vue'

import app from './app.vue'

/* eslint-disable no-new */
new Vue({
  render: h => h(app)
}).$mount('#app')
